<template>
  <a
    href="/"
    class="flex-none items-center gap-2 text-lg font-semibold md:text-base transition-colors"
  >
    <img
      src="../assets/images/xeovision_logomark.svg"
      alt="Xeokit logo"
      class="lg:hidden w-full h-9"
    />
    <div class="hidden lg:block">
      <img
        v-if="colorMode.value === 'dark'"
        src="../assets/images/xeovision_logo_for_dark_bg.svg"
        alt="Xeokit logo"
        class="w-[180px] mt-[2px]"
      />
      <img
        v-else
        src="../assets/images/xeovision_logo_for_light_bg.svg"
        alt="Xeokit logo"
        class="w-[180px] mt-[2px]"
      />
    </div>
  </a>
</template>
<script setup lang="ts">
const colorMode = useColorMode();
</script>
